module.exports = __webpack_public_path__ + "img/walk-icon.1290378b.svg";